import MobileCategoryMenu from '@/components/layouts/mobile-menu/mobile-category-menu';
import { drawerAtom } from '@/store/drawer-atom';
import { useAtom } from 'jotai';
import dynamic from 'next/dynamic';
import Drawer from './drawer';
import { useDrawer } from './useDrawer';
import { searchDrawerAtom } from '@/store/searchDrawerAtom';

const CartSidebarView = dynamic(
  () => import('@/components/cart/cart-sidebar-view'),
);
const MobileAuthorizedMenu = dynamic(
  () => import('@/components/layouts/mobile-menu/mobile-authorized-menu'),
);
const MobileMainMenu = dynamic(
  () => import('@/components/layouts/mobile-menu/mobile-main-menu'),
);
const SearchFilterView = dynamic(
  () => import('@/components/search-view/sidebar-filter-and-categories'),
);
const MaintenanceMoreInfo = dynamic(
  () => import('@/components/maintenance/more-info'),
);

export default function ManagedDrawer({
  atom = drawerAtom,
}: Readonly<{
  atom?: typeof drawerAtom;
}>) {
  const [{ display, view, data }, setDrawerState] = useAtom(atom);
  const { closeDrawer } = useDrawer({
    atom: searchDrawerAtom,
  });

  return (
    <Drawer
      open={display}
      onClose={() => {
        closeDrawer();
        setDrawerState({ display: false, view: '' });
      }}
      variant={
        [
          'FILTER_VIEW',
          'MAIN_MENU_VIEW',
          'FILTER_LAYOUT_TWO_VIEW',
          'SEARCH_FILTER',
        ].includes(view)
          ? 'left'
          : 'right'
      }
      className={
        ['MAINTENANCE_MORE_INFO']?.includes(view) ? 'max-w-sm md:max-w-xl' : ''
      }
    >
      {view === 'cart' && <CartSidebarView />}
      {view === 'FILTER_VIEW' && <MobileCategoryMenu variables={data} />}
      {view === 'MAIN_MENU_VIEW' && <MobileMainMenu variables={data?.variables} />}
      {view === 'AUTH_MENU_VIEW' && <MobileAuthorizedMenu />}
      {view === 'SEARCH_FILTER' && (
        <SearchFilterView
          variables={data?.variables}
          childCategoryNames={data?.childCategoryNames}
        />
      )}
      {view === 'MAINTENANCE_MORE_INFO' && (
        <MaintenanceMoreInfo variables={data} />
      )}
    </Drawer>
  );
}
